import { motion } from "framer-motion";
import { Search, LayoutTemplate, Code2, FileText, TestTube2, BookOpenCheck } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { HOME_I18N } from "../i18n/home";

const AI_BG = "https://static.prod-images.emergentagent.com/jobs/4563ce39-d136-4158-943b-98a85fea66a9/images/b3ed469b8f79e4ebb595fdbbb94870e861a74cd69547ee02c1fbeb9b6c4293d4.png";

const ICONS = [Search, LayoutTemplate, Code2, FileText, TestTube2, BookOpenCheck];

export default function DrAiSection() {
  const { lang } = useLang();
  const t = HOME_I18N[lang].drAi;

  return (
    <section className="section relative overflow-hidden bg-[#07111F] text-white" data-testid="dr-ai-section">
      <div className="absolute inset-0">
        <img src={AI_BG} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20 mix-blend-screen" />
        <div className="absolute inset-0 bg-grid opacity-40" />
        <div className="absolute top-20 right-1/4 h-[360px] w-[360px] rounded-full bg-[#7C3AED]/20 blur-[140px]" />
        <div className="absolute bottom-20 left-1/4 h-[360px] w-[360px] rounded-full bg-[#22D3EE]/15 blur-[140px]" />
      </div>

      <div className="container-x relative grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-6">
          <span className="eyebrow-light">{t.eyebrow}</span>
          <h2 className="mt-3 font-heading font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white">
            {t.title1}<br />
            <span className="text-gradient">{t.titleAccent}</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg leading-relaxed text-white/70">{t.desc1}</p>
          <p className="mt-4 text-base leading-relaxed text-white/60">{t.desc2}</p>
        </div>

        <div className="lg:col-span-6">
          <div className="grid gap-4 sm:grid-cols-2">
            {t.areas.map((a, i) => {
              const Icon = ICONS[i];
              return (
                <motion.div
                  key={a.t}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.4, delay: (i % 2) * 0.06 }}
                  className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 backdrop-blur-xl transition hover:border-[#22D3EE]/30 hover:bg-white/[0.06]"
                  data-testid={`ai-area-${i}`}
                >
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-[#2563EB]/30 to-[#22D3EE]/25 border border-white/10">
                    <Icon className="h-4 w-4 text-[#22D3EE]" />
                  </span>
                  <h3 className="mt-4 font-heading text-base font-semibold text-white">{a.t}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-white/55">{a.d}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
